import { Text } from "@mantine/core";
import React from "react";
import { useSelector } from "react-redux";
import "./styles.css";
import StaleComposer from "./richTextEditor/StaleComposer";

export default function MessageComposer({ images, setImages, handleFileUpload }) {
  const folder = useSelector((state) => state.folder);
  // const message = useSelector((state) => state.message);

  return (
    <>
      <Text size={36} mt={"36px"} mb={"16px"} align={"center"}>
        Telegram Folder Message
      </Text>

      <Text color="dimmed" size={19} w={"90%"}>
        Write the message you’d like to send to all chats in the folder{" "}
        <font color="black">{`"${folder.label}"`}</font>{" "}
      </Text>

      <StaleComposer images={images} setImages={setImages} handleFileUpload={handleFileUpload} />

      <Text mt={"5px"} mb={"40px"} color="dimmed" align={"left"} size={14}>
        Available snippet: {"{{name}}"} – name of channel/user.
      </Text>
    </>
  );
}
